import type { FC } from 'react';
import { Button, InlineNotification, Stack } from '@carbon/react';
import { Email } from '@carbon/icons-react';

import { PaginaDeAuth } from '../../../padroes/PaginaDeAuth';
import { ROTULOS, rotuloDoAviso } from '../../../padroes/rotulos';
import styles from '../auth.module.scss';

// A CONTA EM REVISÃO (declaração de menoridade): o que aconteceu, a garantia curta de que nada foi
// apagado, a explicação do caminho de volta em texto corrido, e as duas ações: escrever ao suporte
// (o primário) e sair.

export const ContaBloqueada: FC<{
  idadeMinima: number;
  emailDoSuporte: string;
  linkDoSuporte: string;
  sair: () => void;
}> = ({ idadeMinima, emailDoSuporte, linkDoSuporte, sair }) => (
  <PaginaDeAuth
    titulo='Seu acesso está temporariamente bloqueado'
    apoio={`A Maestra é destinada a maiores de ${idadeMinima} anos, e a data de nascimento informada indica idade inferior. Seu acesso foi suspenso enquanto revisamos o cadastro.`}
  >
    <InlineNotification kind='info' lowContrast hideCloseButton title='Seus dados continuam guardados.' statusIconDescription={rotuloDoAviso('info')} aria-label={ROTULOS.fecharAviso} />
    <Stack gap={5}>
      <p className={styles.texto}>
        Nada foi apagado. Se houve engano ao informar a data, escreva para{' '}
        <strong className={styles.destaque}>{emailDoSuporte}</strong> e nós corrigimos.
      </p>
      <p className={styles.texto}>
        Esse é também o canal do Encarregado pelo tratamento de dados, por onde você pode pedir a
        exclusão da conta a qualquer momento.
      </p>
    </Stack>
    <div className={styles.acoes}>
      <Button renderIcon={Email} href={linkDoSuporte}>Escrever ao suporte</Button>
      <Button kind='ghost' onClick={sair}>Sair da conta</Button>
    </div>
  </PaginaDeAuth>
);
